/**
 * 挂件 renderer 注册表（§6 / §8）
 *
 * 新 type 接入：type -> lazy(() => import('./renderers/{type}'))。
 *
 * 本期仅注册 recharge_retention（含 h5_recharge_retention_v1 映射）。
 * subscribe_retention 弹窗已接入，挂件 UI 就绪后再写入本表；
 * subscription_discount 仅在 defaults/types 保留。
 * 勿用 Placeholder 占生产注册位。
 */

import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

import type { IActivityWidgetRendererProps } from './types';
import type { TActivityPopupType } from '@/activity-orchestration/types';

type TWidgetRenderer = ComponentType<IActivityWidgetRendererProps>;
type TLazyWidgetRenderer = LazyExoticComponent<TWidgetRenderer>;

/** 占位：仅用于尚未正式接入的 type（如 ops_promo） */
const PlaceholderLazy = lazy(() => import('./placeholder-widget'));
const RechargeRetentionLazy = lazy(() => import('./renderers/recharge-retention'));

/**
 * type → lazy renderer。
 * 未知 / 未注册 type 不在表内 → Host 跳过该挂件。
 */
export const widgetRenderers: Partial<Record<TActivityPopupType, TLazyWidgetRenderer>> = {
    recharge_retention: RechargeRetentionLazy,
    // TODO(popup-list): ops_promo 正式接入后换独立 renderer
    ops_promo: PlaceholderLazy,
};

/** 按 type 取 renderer；无匹配返回 undefined */
export function getWidgetRenderer(type: TActivityPopupType): TLazyWidgetRenderer | undefined {
    return widgetRenderers[type];
}
